/* Ballast Supply — free digital bonuses auto-added to cart, locked. App-free. Defensive: never breaks the cart. */
(function () {
  var GIFTS = [53531203895643, 53531203928411, 53531203961179];
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false, mine = false, lastMutate = 0;
  function isGift(id) { return GIFTS.indexOf(id) > -1; }

  // ---- cosmetic: hide qty/remove on gift lines, add a FREE tag ----
  try {
    var css = document.createElement('style');
    css.textContent =
      '[data-pl-gift] cart-remove-button,[data-pl-gift] .cart-item__quantity-wrapper,[data-pl-gift] quantity-input,' +
      '[data-pl-gift] .quantity,[data-pl-gift] .cart-item__quantity{visibility:hidden!important}' +
      '.pl-gift-tag{display:inline-block;margin-top:3px;font:700 10px/1 "Montserrat",sans-serif;letter-spacing:.5px;' +
      'color:#00b67a;border:1px solid #00b67a;border-radius:4px;padding:2px 6px;text-transform:uppercase}';
    document.head.appendChild(css);
  } catch (e) {}

  function markLines() {
    try {
      GIFTS.forEach(function (g) {
        document.querySelectorAll('a[href*="variant=' + g + '"]').forEach(function (a) {
          var row = a.closest('tr.cart-item, .cart-item, [class*="cart-item"], cart-drawer-item');
          if (!row || row.getAttribute('data-pl-gift')) return;
          row.setAttribute('data-pl-gift', '1');
          if (!row.querySelector('.pl-gift-tag')) {
            var host = row.querySelector('.cart-item__details, .cart-item__name') || row;
            var tag = document.createElement('div'); tag.className = 'pl-gift-tag'; tag.textContent = 'Free gift';
            host.appendChild(tag);
          }
        });
      });
    } catch (e) {}
  }

  function refreshUI() {
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        try {
          if (s['cart-drawer']) {
            var d = document.querySelector('cart-drawer');
            var nn = new DOMParser().parseFromString(s['cart-drawer'], 'text/html').querySelector('cart-drawer');
            if (d && nn) { d.innerHTML = nn.innerHTML; d.classList.toggle('is-empty', nn.classList.contains('is-empty')); }
          }
          if (s['cart-icon-bubble']) {
            var b = document.getElementById('cart-icon-bubble');
            var nb = new DOMParser().parseFromString(s['cart-icon-bubble'], 'text/html').getElementById('cart-icon-bubble');
            if (b && nb) b.innerHTML = nb.innerHTML;
          }
        } catch (e) {}
        markLines();
      }).catch(function () {});
  }

  function reconcile() {
    if (busy) return Promise.resolve();
    busy = true; mine = true;
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var paid = 0, gq = {};
        (cart.items || []).forEach(function (it) { if (isGift(it.variant_id)) gq[it.variant_id] = it.quantity; else paid += it.quantity; });
        var adds = [], updates = {};
        if (paid > 0) {
          GIFTS.forEach(function (g) { if (!gq[g]) adds.push({ id: g, quantity: 1 }); else if (gq[g] !== 1) updates['' + g] = 1; });
        } else {
          GIFTS.forEach(function (g) { if (gq[g]) updates['' + g] = 0; });
        }
        var chain = Promise.resolve(), changed = false;
        if (adds.length) { changed = true; chain = chain.then(function () { return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: adds }) }); }); }
        if (Object.keys(updates).length) { changed = true; chain = chain.then(function () { return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) }); }); }
        return chain.then(function () { if (changed) return refreshUI(); markLines(); });
      })
      .catch(function () {})
      .then(function () { busy = false; setTimeout(function () { mine = false; }, 350); });
  }

  // intercept cart mutations (customer add/remove) -> reconcile. Bulletproof passthrough.
  try {
    var _fetch = window.fetch;
    window.fetch = function () {
      var out = _fetch.apply(this, arguments);
      try {
        var u = arguments[0]; u = (u && u.url) || u || '';
        if (typeof u === 'string' && /\/cart\/(add|change|update|clear)/.test(u) && !mine) {
          out.then(function () { var n = Date.now(); if (n - lastMutate > 250) { lastMutate = n; setTimeout(reconcile, 80); } }).catch(function () {});
        }
      } catch (e) {}
      return out;
    };
  } catch (e) {}

  // re-lock when the drawer re-renders on its own (debounced)
  try { var mt; new MutationObserver(function () { clearTimeout(mt); mt = setTimeout(markLines, 150); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
  if (document.readyState !== 'loading') { reconcile(); } else { document.addEventListener('DOMContentLoaded', reconcile); }
})();
